import { IBusinessAccountsItemLocation } from 'interfaces'

export const Location: TAnt.TableColumnRender<IBusinessAccountsItemLocation> = ({
  cityName = '',
  code = ''
}) => <>{cityName && code ? `${cityName}, ${code.toLocaleUpperCase()}` : 'N/A'}</>
